module.exports = require("material-ui/Checkbox");


//////////////////
// WEBPACK FOOTER
// external "material-ui/Checkbox"
// module id = 364
// module chunks = 0